var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "nav-account" },
    _vm._l(_vm.navBar, function(item, i) {
      return _c(
        "router-link",
        {
          directives: [
            {
              name: "profile-guard",
              rawName: "v-profile-guard",
              value: item.action,
              expression: "item.action"
            }
          ],
          key: i,
          staticClass: "nav-account__item",
          attrs: {
            "active-class": "active",
            to: { name: item.route },
            exact: item.exact
          }
        },
        [_vm._v(" " + _vm._s(_vm.$t(item.label)))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }